import { render, staticRenderFns } from "./patient-merge-set.vue?vue&type=template&id=4cfc3266&scoped=true&lang=pug&"
import script from "./patient-merge-set.vue?vue&type=script&lang=ts&"
export * from "./patient-merge-set.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfc3266",
  null
  
)

export default component.exports